import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

// function getCustomAddress (report) {
//   let address = ''
//   let ward = ''
//   let union = ''
//   let city = ''
//   let sabha = ''
//   let upazila = ''
//   let district = ''

//   if (report.pre_address || report.pre_address_bn) {
//     address = (i18n.locale === 'bn' ? report.pre_address_bn : report.pre_address) + ', '
//   }
//   if (report.pre_ward_id) {
//     ward = (i18n.locale === 'bn' ? report.ward_name_bn : report.ward_name) + ', '
//   }
//   if (report.pre_union_id) {
//     union = (i18n.locale === 'bn' ? report.union_name_bn : report.union_name) + ', '
//   }
//   if (report.pre_city_corporation_id) {
//     city = (i18n.locale === 'bn' ? report.city_corp_name_bn : report.city_corp_name) + ', '
//   }
//   if (report.pre_paurasabha_id) {
//     sabha = (i18n.locale === 'bn' ? report.pauroshoba_name_bn : report.pauroshoba_name) + ', '
//   }
//   if (report.pre_upazila_id) {
//     upazila = (i18n.locale === 'bn' ? report.upazila_name_bn : report.upazila_name) + ', '
//   }
//   if (report.pre_district_id) {
//     district = (i18n.locale === 'bn' ? report.district_name_bn : report.district_name)
//   }

//   const result = address + ward + union + city + sabha + upazila + district
//   return result
// }

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                  { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                  { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
                ],
                [
                  {},
                  { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: reportHeadData.address, style: 'address', alignment: 'center' },
                  {}
                ],
                [
                  {},
                  { text: 'www.spst.gov.bd', style: 'td2', alignment: 'center' },
                  {}
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
        pdfContent.push(
          { text: reportTitle, style: 'header', alignment: 'center', decoration: 'underline' }
        )
        const allRowsHead = [
          [
            { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.institute_name_address'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.approved_seats'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.no_residents'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.residents_admitted'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_resident'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_rehabilitation_month'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_release_month'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_residents_month'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_rehabilitated_residents_admission'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_rehabilitated_residents'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.total_release_residents'), style: 'th', alignment: 'center' },
            { text: vm.$t('child_reports.Comments'), style: 'th', alignment: 'center' }
          ],
          [
            { text: vm.$n(1), style: 'th', alignment: 'center' },
            { text: vm.$n(2), style: 'th', alignment: 'center' },
            { text: vm.$n(3), style: 'th', alignment: 'center' },
            { text: vm.$n(4), style: 'th', alignment: 'center' },
            { text: vm.$n(5), style: 'th', alignment: 'center' },
            { text: vm.$n(4) + '+' + vm.$n(5) + '=' + vm.$n(6), style: 'th', alignment: 'center' },
            { text: vm.$n(7), style: 'th', alignment: 'center' },
            { text: vm.$n(8), style: 'th', alignment: 'center' },
            { text: vm.$n(6) + '-' + '(' + vm.$n(7) + '+' + vm.$n(8) + ')' + '=' + vm.$n(9), style: 'th', alignment: 'center' },
            { text: vm.$n(10), style: 'th', alignment: 'center' },
            { text: vm.$n(11), style: 'th', alignment: 'center' },
            { text: vm.$n(12), style: 'th', alignment: 'center' },
            { text: vm.$n(13), style: 'th', alignment: 'center' }
          ]
        ]
          allRowsHead.push(
          [
            { text: vm.$n(1), style: 'td', alignment: 'center' },
            // { text: vm.$i18n.locale === 'bn' ? report.institute_name_bn : report.institute_name, style: 'td', alignment: 'left' },
            { text: vm.titleData.institute_name, style: 'td', alignment: 'left' },
            { text: vm.$n(data.approved_seats), style: 'td', alignment: 'left' },
            { text: vm.$n(data.no_residents), style: 'td', alignment: 'left' },
            { text: vm.$n(data.residents_admitted), style: 'td', alignment: 'left' },
            { text: vm.$n(data.no_residents + data.residents_admitted), style: 'td', alignment: 'left' },
            { text: vm.$n(data.total_release_month), style: 'td', alignment: 'left' },
            { text: vm.$n(data.total_rehabilitation_month), style: 'td', alignment: 'left' },
            { text: vm.$n(data.no_residents + data.residents_admitted - data.total_release_month - data.total_rehabilitation_month), style: 'td', alignment: 'left' },
            { text: vm.$n(data.total_rehabilitated_residents_admission), style: 'td', alignment: 'left' },
            { text: vm.$n(data.total_rehabilitated_residents), style: 'td', alignment: 'left' },
            { text: vm.$n(data.total_release_residents), style: 'td', alignment: 'left' },
            { text: vm.report_data.Comments, style: 'td', alignment: 'left' }
          ])
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['50%', '50%'],
              body: [

                  [
                    { },
                    { }
                  ],
                [
                  { text: vm.$t('globalTrans.organization') + ': ' + (titleData.org_name ? titleData.org_name : vm.$t('globalTrans.all')), style: 'td', alignment: 'left' },
                  { text: vm.$t('child_configuration.institute_name') + ': ' + (titleData.institute_name ? titleData.institute_name : vm.$t('globalTrans.all')), style: 'td', alignment: 'right' }
                ],
                [
                  { text: vm.$t('child_configuration.institute_type') + ': ' + (titleData.institute_type_name ? titleData.institute_type_name : vm.$t('globalTrans.all')), style: 'td', alignment: 'left' },
                  { text: vm.$t('globalTrans.year') + ': ' + (titleData.year ? titleData.year : vm.$t('globalTrans.all')), style: 'td', alignment: 'right' }
                ]
              ]
            },
            layout: {
                hLineWidth: function (i, node) {
                  return 0
                },
                vLineWidth: function (i, node) {
                  return 0
                }
              }
          }
        )
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['4%', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*'],
            body: allRowsHead
          }
        })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজ কল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'landscape',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
            th: {
              fillColor: '#dee2e6',
              fontSize: 9,
              margin: [3, 3, 3, 3]
            },
            th1: {
                fontSize: 9
              },
            td: {
              fontSize: 8,
              margin: [3, 3, 3, 3]
            },
            td2: {
                border: 0,
                fontSize: 10,
                alignment: 'center'
              },
            header: {
              margin: [0, 10, 0, 10],
              fontSize: 14,
              alignment: 'center'
            },
            header2: {
              border: 0,
              fontSize: 14,
              margin: [0, 0, 0, 1]
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 15,
              alignment: 'center'
            },
            address: {
              border: 0,
              fontSize: 10,
              bold: true,
              margin: [0, 0, 0, 1]
            },
            left_logo: {
              borderRadius: 50
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print() // 'report')
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
